import React from 'react';
import OrderManagementListSearchBox from '../OrderManagementListSearchBox';
import OrderManagementList from '../OrderManagementList';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ORDER_MANAGEMENT_LIST_MODEL } from '../../../../../store/modules/order/models';
import { setViewPeriod } from '../../../../../lib/common';

const OrderManagementListWrap = (props) => {
  const {
    orderManagementList,
    setData,
    getList,
    deliveryPreparation,
    deliveryDelay,
    checkDeliveryDispatch,
    onChangeDeliveryInfo,
    applyBulkDeliveryInfo,
    onCheckOrderItem,
    excelBulkDeliveryDispatch,
    cancelSales,
    editBuyerInfo,
    editDeliveryInfo,
    getAllManagementListExcelDownLoad,
    getSelectedManagementListExcelDownLoad,
  } = props;
  const {
    orderItemStatusList,
    deliveryType,
    orderItemDetailSearch,
    viewPeriod,
    productType,
    store,
    orderTypeList,
    giftStatusList,
  } = orderManagementList.searchData;

  return (
    <div className="order-management-list-wrap">
      {/*검색 박스*/}
      <OrderManagementListSearchBox
        setData={(data) =>
          setData({
            path: ['orderManagementList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={orderManagementList.searchData}
        onSearch={() =>
          getList({
            searchOption: {
              /**
               *  상품 주문 상태 리스트
               */
              orderItemStatusList,
              /**
               *  택배 배송 방법
               */
              deliveryType,
              /**
               *  상세 검색
               */
              orderItemDetailSearch,
              /**
               *  조회기간
               */
              viewPeriod: setViewPeriod(viewPeriod.quickDateIndex, viewPeriod),
              /**
               *  상품타입
               */
              productType,
              /**
               *  관리처
               */
              store,
              /**
               *  주문 타입
               */
              orderTypeList,
              /**
               *  선물 상태
               */
              giftStatusList,
            },
            pagination: _LIST_PAGINATION_MODEL,
          })
        }
        onClear={() =>
          setData({
            path: ['orderManagementList'],
            value: ORDER_MANAGEMENT_LIST_MODEL,
          })
        }
      />

      {/*주맨/배송관리 리스트*/}
      <OrderManagementList
        orderManagementList={orderManagementList}
        setData={setData}
        getList={getList}
        deliveryPreparation={deliveryPreparation}
        deliveryDelay={deliveryDelay}
        checkDeliveryDispatch={checkDeliveryDispatch}
        onChangeDeliveryInfo={onChangeDeliveryInfo}
        applyBulkDeliveryInfo={applyBulkDeliveryInfo}
        onCheckOrderItem={onCheckOrderItem}
        excelBulkDeliveryDispatch={excelBulkDeliveryDispatch}
        cancelSales={cancelSales}
        editBuyerInfo={editBuyerInfo}
        editDeliveryInfo={editDeliveryInfo}
        getAllManagementListExcelDownLoad={getAllManagementListExcelDownLoad}
        getSelectedManagementListExcelDownLoad={getSelectedManagementListExcelDownLoad}
      />
    </div>
  );
};

export default OrderManagementListWrap;
